
import { For, Show, createEffect, createResource, createSignal, onMount } from "solid-js";
import { getMeasureTypeOption } from "../js/variantsUtil";
import { InfoIcon } from "./InfoIcon";
import { ModalV3 } from "./Modal";
import { PromoSaleContainer } from "./PromoSaleContainer";
import { calculateDiscountedPrice, formatPrice } from "../js/utils";
import { PresalePriceContainer } from "./PresalePriceContainer";
import { RegularDiscountPriceContainer, RegularDiscountPriceContainerV2 } from "./RegularPriceContainer";


const [isDiscountApplied, setIsDiscountApplied] = createSignal(false);

const getCookie = (cookieName) => {
  var cookiestring = RegExp(cookieName + "=[^;]+").exec(document.cookie);
  return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./, "") : "");
}


export const HeroPolicy = (props) => {
  const {
    productInfo,
    getters: { getExperimentFlags },
  } = props.context();

  async function handleApplyDiscountClick() {
    if (props.showApplyButton == false || (typeof (Shopify) != 'undefined' && Shopify?.country != undefined && Shopify.country == 'IN')) return;

    await window.applyDiscountCode({ title: productInfo.title, pathname: window.location.pathname });
    props.setIsDiscountApplied(true)
  }

  return (
    <Show when={props.policyText && !props.discountStatus} >
      <div class="policyText flex items-center" classList={{
        // "mt-1": props.isModal != true
      }}>
        <div
          class="text-sm flex item-center gap-1 text-ink bg-canvas-light cursor-pointer rounded-xl justify-between font-regular w-auto"
          onclick={handleApplyDiscountClick}
        >
          <div class="py-1 px-1" innerHTML={`${props.discountPrice} with code <strong>${props.discountCode}</strong>`} />
          <Show when={props.showApplyButton != false && (typeof (Shopify) != 'undefined' && Shopify?.country != undefined && Shopify.country != 'IN')}>
            <button class="text-ink-link font-regular rounded-e-xl bg-canvas-light border-frame border-l-inner  hover:underline px-1 py-1 font-bold shrink-0" >Apply now</button>
          </Show>
        </div>
      </div>
    </Show>
  )
}

const getCurrencyConversionInfo = (productInfo) => {
  const { currency, currencySymbol, currencyConversionRate = 1 } = productInfo;

  return { currency, currencySymbol, currencyConversionRate };
}

export const ProductPriceInfo = (props) => {
  const {
    sizeSettings: {
      sendRefData,
      measurementOptionsV2
    },
    color: {
      color
    },
    customer: {
      metafield: customerMetafield
    },
    heroSectionSettings,
    reviewProfilePictures,
    getters: { getExperimentFlags, isExperimentEnabled }
  } = props.context()
  let couponCodeRef;
  const {
    preLaunchEnabled,
    preLaunchCloseDate
  } = props.productInfo;
  const today = new Date();

  const presaleEnabled = props.productInfo?.presale?.enabled;
  const presaleCloseDate = props.productInfo?.presale?.end_date;
  const currencyConversion = getCurrencyConversionInfo(props.productInfo);

  const showPreLaunch = () => {
    if (preLaunchEnabled == undefined || preLaunchEnabled == null || preLaunchEnabled == false) return false;
    if (preLaunchCloseDate == undefined || preLaunchCloseDate == null || today.getTime() > preLaunchCloseDate.getTime()) return false;

    return true;
  }

  const showPreSale = () => {
    if (presaleEnabled == undefined || presaleEnabled == null || presaleEnabled == false) {
      return false;
    }
    if (presaleCloseDate == undefined || presaleCloseDate == null || today.getTime() > presaleCloseDate.getTime()) {
      return false;
    }

    return true;
  }

  const currentVariant = () => {
    const measurementOptionSelected = measurementOptionsV2['selected'];
    const colorSelected = color().selected;

    const measureTypeOption = getMeasureTypeOption(measurementOptionSelected, measurementOptionsV2.options, customerMetafield, sendRefData());

    return props.productInfo['variants'][measureTypeOption][colorSelected]
  }

  const presalePrice = () => {
    if (!showPreSale()) return null;

    const { price } = currentVariant();
    const discountValue = parseFloat(`${props.productInfo.presale.discount_value}`)
    const discountType = props.productInfo.presale.discount_type;
    if (isNaN(discountValue)) return null;

    const newPrice = calculateDiscountedPrice(price, discountValue, discountType);

    return formatPrice(newPrice, currencyConversion);
  }

  const prelaunchCloseText = () => {
    if (today.toDateString() == preLaunchCloseDate.toDateString()) return "today";

    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    if (tomorrow.toDateString() == preLaunchCloseDate.toDateString()) return "tomorrow";

    return preLaunchCloseDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  }

  const price = () => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const { price } = currentVariant();

    return formatPrice(price, currencyConversion);
  }

  const discountPrice = (force = false) => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const discount_cookie = getCookie('discount_code');

    if (handleize(discount_cookie ?? "") !== handleize(props.discountCode) && force != true) {
      return null;
    }

    const { price } = currentVariant();

    const newPrice = calculateDiscountedPrice(price, props.discountValue, 'percentage');
    return formatPrice(newPrice, currencyConversion);
  }


  const compareAtPrice = () => {
    isDiscountApplied(); // used as an effect to rerun the price on isDiscountApplied state change

    const { compareAtPrice } = currentVariant();

    return formatPrice(compareAtPrice, currencyConversion);
  }



  const isPromotionExpired = (variantPromo, productPromo) => {
    const startDate = (variantPromo.discount ? variantPromo.startDate : productPromo.startDate)?.getTime();
    const endDate = (variantPromo.discount ? variantPromo.endDate : productPromo.endDate)?.getTime();
    const now = new Date().getTime()

    return (startDate != undefined && endDate != undefined && (now < startDate || now > endDate))
  }

  const promotionalPrice = () => {
    const colorSelected = color().selected;

    const variantPromo = props.productInfo.variants.standard[colorSelected].promotions;
    const productPromo = props.productInfo.promotions;

    if (!props.productInfo.showDiscountedPrice) return null;

    if (variantPromo.discount == null && productPromo.discount == null) return null;

    if (isPromotionExpired(variantPromo, productPromo)) return null;

    const { price } = currentVariant();
    const discountPercentage = parseFloat(variantPromo.discount ?? productPromo.discount)
    if (isNaN(discountPercentage)) return null;

    const newPrice = calculateDiscountedPrice(price, discountPercentage, 'percentage');

    return formatPrice(newPrice, currencyConversion);
  }

  const promotionAvailable = () => {
    const productPromo = props.productInfo.promotions;
    const variantsPromos = Object.values(props.productInfo.variants.standard)
      .map(v => v.promotions)
      .filter(p => p.discount != null)
      .filter(vp => !isPromotionExpired(vp, productPromo));

    return props.productInfo.showDiscountedPrice && (variantsPromos.length > 0 || productPromo.discount != null);
  }

  const promotionalText = () => {
    const colorSelected = color().selected;
    const variantPromo = props.productInfo.variants.standard[colorSelected].promotions;
    const productPromo = props.productInfo.promotions;

    if (variantPromo.discount == null && productPromo.discount == null) return null;

    return variantPromo.bannerText ?? productPromo.bannerText;
  }

  const promotionalImage = () => {
    const colorSelected = color().selected;
    const variantPromo = props.productInfo.variants.standard[colorSelected].promotions;
    const productPromo = props.productInfo.promotions;

    if (variantPromo.discount == null && productPromo.discount == null) return null;

    return variantPromo.image ?? productPromo.image;
  }

  const finalBasePrice = () => {
    if (price() && (discountPrice() == null || promotionalPrice() != null || (discountPrice() != null && promotionAvailable()) || (BRAND.discount.messagingType === 'MARKDOWN'))) {
      return price()
    } else {
      return discountPrice()
    }
  }
  const finalCompareAtPrice = () => {
    if ((price() && discountPrice() && promotionalPrice() == null && !promotionAvailable() && BRAND.discount.messagingType != 'MARKDOWN')) {
      return price()
    }
    else {
      return compareAtPrice()
    }
  }

  const finalDiscountPercentage = () => {
    let price = Number(finalBasePrice().replace(/[^0-9\.-]+/g, ""))
    let compareAt = Number(finalCompareAtPrice().replace(/[^0-9\.-]+/g, ""))
    return Math.round((1 - price / compareAt) * 100)

  }

  const [presalePageTitle, setPresalePageTitle] = createSignal('');
  const [presaleInfoPage] = createResource(() => props.productInfo?.presale?.url, (url) => {
    if (url) {
      return fetch(url)
        .then(res => res.text())
        .then(text => {
          if (text == undefined) return null;

          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const section = doc?.querySelector('section.shopify-section');

          section?.querySelector('div.container')?.classList?.remove('mt-12')
          section?.querySelector('div.container')?.classList?.remove('md:px-10')
          section?.querySelector('div.container')?.classList?.remove('sm:px-5')
          section?.querySelector('div.container')?.classList?.remove('lg:my-10')
          section?.querySelector('div.container')?.classList?.add('mt-2')

          const title = section?.querySelector('article')?.querySelector('h1')?.innerText;
          setPresalePageTitle(title ?? '');
          section?.querySelector('article')?.querySelector('h1')?.classList.add('hidden');

          return section;
        });
    }
    return null;
  });

  const [modalState, setModalState] = createSignal(false);
  const handleModalOpenState = (state) => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = state ? 'hidden' : '';



    setModalState(state);
  }

  const presaleData = {
    ACTUAL_PRICE: `<span class="" >Regular Price: ${price()}</span>`,
    DISCOUNTED_PRICE: `<span class="py-1 font-semibold text-sale-700">Pre-order Price: ${presalePrice()}</span>`
  }

  return (
    <div class="my-2">
      <Show when={showPreSale() && props.productInfo?.presale}>
        <div class="bg-sale-600 flex font-bold gap-x-0.5 items-center mt-0.5 px-[6px] py-0.5 rounded-lg text-canvas text-center text-xs w-fit">
          <div class="text-2xs sm:text-xs">{props.productInfo.presale?.pdp_badge_text}</div>
        </div>
        <div onClick={() => handleModalOpenState(true)} class="cursor-pointer flex hover:text-secondary-400 items-center mt-1 text-xs text-ink-link gap-0.5 text-left w-max"><InfoIcon /> {props.productInfo.presale?.how_it_works_title}</div>
        <ModalV3
          title={presalePageTitle()}
          modalState={modalState()}
          handleModalOpenState={handleModalOpenState}
          modalClass={"sm:max-w-fit"}
        >
          {presaleInfoPage()}
        </ModalV3>
      </Show>

      <div
        class="font-mono text-base 2xl:text-lg mt-2 mb-1 ">
        <Show
          when={showPreSale() && props.productInfo.presale.price_format != undefined}
          fallback={(
            <div class="flex gap-1 items-baseline">
              <span class="base-product-price" >{finalBasePrice()}</span>
              <Show when={(price() && discountPrice() && promotionalPrice() == null && !promotionAvailable()) || BRAND.discount.messagingType === 'MARKDOWN'} >
                <Show when={finalDiscountPercentage() > 1}>
                  <span class="line-through opacity-50" >{finalCompareAtPrice()}</span>

                  <span class="text-sale-500 text-xs">({finalDiscountPercentage()}% OFF)</span>
                </Show>

              </Show>
            </div>
          )}
        >
          <div class="gap-1 items-baseline text-sale-700 text-sm"
            innerHTML={props.productInfo.presale.price_format.replace(/{{(.*?)}}/g, (_, key) => {
              return presaleData[key.trim()];
            })}
          />
        </Show>

        <Show when={heroSectionSettings.showShippingPolicy}>
          <span
            class="text-2xs font-regular"
            classList={{
              "px-1": !showPreSale()
            }}
          >(Inclusive of shipping & taxes)</span>
        </Show>
      </div>
      <Show when={showPreLaunch() && compareAtPrice() && promotionalPrice() == null}>
        <p class="">{`Special pre-launch price until`} <strong>{prelaunchCloseText()}</strong></p>
      </Show>

      {/* <Show when={showPreSale() && compareAtPrice() && promotionalPrice() == null}>
        <p class="">{`Special pre-launch price until`} <strong>{prelaunchCloseText()}</strong></p>
      </Show> */}

      <Show
        when={promotionalPrice()}
        fallback={(
          <Show when={BRAND.discount.messagingType === 'FIRSTBUY' && !showPreSale()}>
            <HeroPolicy
              discountPrice={discountPrice(true)}
              policyText={heroSectionSettings.policyText}
              discountCode={heroSectionSettings.discountCode}
              discountStatus={isDiscountApplied()}
              setIsDiscountApplied={setIsDiscountApplied}
              context={props.context}
              isModal={props.isModal}
              showApplyButton={!promotionAvailable()}
            />
          </Show>
        )}
      >
        <PromoSaleContainer
          discountedPrice={promotionalPrice()}
          image={promotionalImage()}
          text={promotionalText()}
        />
      </Show>

      <Show when={!promotionAvailable()}>
        <div
          ref={couponCodeRef}
          class="hero-coupon-msg appliedDiscountContainer max-w-max block text-xs 2xl:text-sm rounded-lg text-secondary-500 text-left font-regular border border-dashed border-secondary-500 hidden"
          classList={{
            "p-0.5 mt-0.5": props.isModal == true,
            "p-1 my-1": props.isModal != true
          }}
        >
          <p class="confirmationMessage">Coupon code <span class="uppercase code underline"></span> applied</p>
        </div>
      </Show>
    </div>
  )
}

export const ProductPriceInfoNew = (props) => {
  const {
    sizeSettings: {
      sendRefData,
      measurementOptionsV2
    },
    color: {
      color
    },
    customer: {
      metafield: customerMetafield
    },
    heroSectionSettings,
    reviewProfilePictures,
    getters: { getExperimentFlags, isExperimentEnabled }
  } = props.context()
  const today = new Date();

  const presaleEnabled = props.productInfo?.presale?.enabled;
  const presaleCloseDate = props.productInfo?.presale?.end_date;
  const currencyConversion = getCurrencyConversionInfo(props.productInfo);

  const showPreSale = () => {
    if (presaleEnabled == undefined || presaleEnabled == null || presaleEnabled == false) {
      return false;
    }
    if (presaleCloseDate == undefined || presaleCloseDate == null || today.getTime() > presaleCloseDate.getTime()) {
      return false;
    }

    return true;
  }

  const currentVariant = () => {
    const measurementOptionSelected = measurementOptionsV2['selected'];
    const colorSelected = color().selected;

    const measureTypeOption = getMeasureTypeOption(measurementOptionSelected, measurementOptionsV2.options, customerMetafield, sendRefData());

    return props.productInfo['variants'][measureTypeOption][colorSelected]
  }

  if (showPreSale()) {
    return (
      <PresalePriceContainer
        showShippingPolicy={heroSectionSettings.showShippingPolicy}
        productInfo={props.productInfo}
        currentVariant={currentVariant}
        isDiscountApplied={isDiscountApplied}
        currencyConversion={currencyConversion}
      />
    )
  }

  return (
    <RegularDiscountPriceContainerV2
      productInfo={props.productInfo}
      showShippingPolicy={heroSectionSettings.showShippingPolicy}
      currentVariant={currentVariant}
      currencyConversion={currencyConversion}
      discount={{
        value: props.discountValue,
        code: props.discountCode
      }}
    />
  )

}